


(function initPackageDiscount() {
  const code = "ΠΑΚΕΤΟ ΓΑΜΟΥ"
  
  document.addEventListener('on:cart:change', handleChange);
  document.addEventListener('on:cart:add', handleChange);

  function refreshCart() {
    document.dispatchEvent(
      new CustomEvent('on:cart:change', { detail: {trigger: "package_discount"} })
    );
  }

  async function handleChange(e) {
    if (e.detail?.trigger === "package_discount") {
      return
    }
    const res = await fetch("/cart.js")
    const cart = await res.json()

    const productHandles = cart.items.map(l => l.url.split("products/")[1].split("?")[0])
    const helperRes = await fetch(`/search?q=${productHandles.join(",")}&section_id=package-discount-helper`)
    const helperTest = await helperRes.text()

    const applies = new DOMParser().parseFromString(helperTest, "text/html").querySelector("div").innerText.trim() === "true";

    const hasPrevDiscount = cart.items.some(l => l.discounts.some(d => d.title === code))
    console.log({hasPrevDiscount, items: cart.items})
    
    if (applies) {
      await fetch(`/discount/${code}`)
      refreshCart()
    } else if (hasPrevDiscount) {
      await fetch(`/discount/CLEAR`)
      refreshCart()
    }
  }
})()

